import { Component, Inject } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MapHelperService } from "../../../../../../../../../services/map-helper.service";
import { Subscription } from 'rxjs';
import { addGeofencesRequestDTO } from 'src/app/features/map-features/sections/geofences-section/models/addGeofences/addGeofencesRequestDTO';
import { GeofencesService } from 'src/app/features/map-features/sections/geofences-section/services/Geofences.service';
import { EnumGeometryTypes } from 'src/app/features/shared/helpers/enums/EnumGeometryTypes';
import { EnumsService } from 'src/app/features/shared/services/ServiceCatalogEncapsulators/Enums.service';
import { SwalNotificationService } from 'src/app/features/shared/services/SwalNotification.service';
import { ValetParkingMapService } from '../../../../services/ValetParkingMap.service';
import { LocalStorageService } from 'src/app/features/shared/services/LocalStorage.service';
import { environment } from "src/environments/environment";
import { EnumGeofenceTypes } from 'src/app/features/shared/helpers/enums/EnumGeofenceTypes';

@Component({
  selector: 'app-valet-parking-map',
  templateUrl: './valet-parking-map.component.html',
  styleUrls: ['./valet-parking-map.component.css']
})
export class ValetParkingMapComponent {

  step: number = 1;
  identificador: string;
  descripcion: string;
  options: string[] = ['10m', '20m', '50m', '80m', '100m'];
  selectedOption: string = '10m';
  mail: string  = "";
  phone: string  = "";
  valetParkingRequest: addGeofencesRequestDTO;

  subscription_InsertV2:Subscription;

  constructor(
    private mapHelperService: MapHelperService,
    private valetParkingMapService: ValetParkingMapService,
    private notifyService: SwalNotificationService,
    private GeofencesAPIService: GeofencesService,
    private enumCatalogsService: EnumsService,
    public dialogRef: MatDialogRef<ValetParkingMapComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private localStorageService: LocalStorageService,
  ) {
    this.identificador = data.identificador;
    this.descripcion = data.descripcion;
  }

  ngOnInit(): void {
    this.createBuffer();
    this.mail = this.localStorageService.getUser();
  }

  nextStep() {
    if (this.step < 2) {
      this.step++;
    }
  }

  prevStep() {
    if (this.step > 1) {
      this.step--;
    }
  }

  selectOption(option: string) {
    this.selectedOption = option;

    this.valetParkingMapService.bufferRadioKm = (parseInt(option.replace('m', '')))/1000;

    this.valetParkingMapService.UpdateValetParkingBuffer();
  }

  createBuffer(){
    this.selectedOption = '10m';
    this.valetParkingMapService.bufferRadioKm = (parseInt(this.selectedOption.replace('m', '')))/1000;

    this.valetParkingMapService.CreateValetParkingDragEvent();
  }

  SendData(){

    if(!this.valetParkingMapService.VerifyCarInValetParking(this.identificador)){
      this.notifyService.MessageError('El Vehículo no se encuentra dentro del radio establecido para Valet Parking');
      return;
    }

    if(this.mail == ""){
      this.notifyService.MessageError('Agregue un correo de notificación');
      return;
    }

    var enums = this.enumCatalogsService.GetGeofenceEnums();

    if (this.valetParkingMapService.coordsValetParking.lat != 0 && this.valetParkingMapService.coordsValetParking.lng != 0) {
      this.valetParkingRequest = {
        identifiers: [this.identificador],
        coords : [[this.valetParkingMapService.coordsValetParking.lat.toString(), this.valetParkingMapService.coordsValetParking.lng.toString()]],
        multiplePolygonCoords: [],
        radio: this.valetParkingMapService.bufferRadioKm.toString(),
        name: "Valet Parking " + this.identificador,
        status: true,
        emailAlert: this.mail,
        phoneAlert: this.phone,
        idGeofenceCategory : Number(enums.GeofenceCategories.find(x => x.value == "ValetParking")?.key),
        idGeofenceType: EnumGeofenceTypes.SecureZone_AlertOnExit,
        // idGeofenceType: [Number(enums.GeofenceTypes.find(x => x.value == "Area Segura - Alerta al Salir").key)],
        idGeometryType: EnumGeometryTypes.Buffer,
        alarmType: "0",
        alarmFrecuency: "0",
        alarmDays: [],
        alarmIndividualTime: [],
        alarmRangeTime: [],
        guid: null
      }
      this.subscription_InsertV2 = this.GeofencesAPIService.InsertV2(this.valetParkingRequest).subscribe({
        next: (data) => {
          if(!environment.production) console.log("RESPONSE",data);
          if(data.isSuccess){
            this.notifyService.MessageSuccessful("Actvado","Se ha activado el Valet Parking");
            this.valetParkingMapService.existValetParking = true;
            this.valetParkingMapService.DeleteValetParkingDragEvent();
            this.valetParkingMapService.ResetValetParkingActiveBuffer();
            this.dialogRef.close(true);
          }else{
            this.notifyService.MessageError("No se pudo crear el área, contacte al administrador");
            Sentry.captureMessage('ValetParkingMap.SendData: isSuccess false', { level: 'warning', extra: { response: data } });
          }
        },
        error: (error) => {
          // TODO marca para complete despues
          console.error('Error al crear Valet Parking', error);
          this.notifyService.MessageError("No se pudo crear el área, contacte al administrador");
        }
      });
    }else{
      this.notifyService.MessageError("No se han seleccionado coordenadas para el Valet Parking");
    }
  }

  CloseDialog() {
    this.valetParkingMapService.DeleteValetParkingDragEvent();
    this.valetParkingMapService.ResetValetParkingActiveBuffer();
    this.dialogRef.close(false);
  }

}
